"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("../");

var _AssignedDriver = _interopRequireDefault(require("../AssignedDriver"));

var _LogisticTaskStatus = _interopRequireDefault(require("../LogisticTaskStatus"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskTypeEnum;

(function (TaskTypeEnum) {
  TaskTypeEnum["collection"] = "collection";
  TaskTypeEnum["delivery"] = "delivery";
})(TaskTypeEnum || (TaskTypeEnum = {}));

const confirmationAlert = (type, action) => {
  if (_reactNative.Platform.OS === "web") {
    let confirmed = confirm(`آیا از لغو ${type === "delivery" ? "تحویل" : "جمع آوری"} مطمئن هستید؟`);

    if (confirmed && action) {
      action();
    } else {}
  } else {
    _reactNative.Alert.alert("ذخیره تغییرات", `آیا از لغو ${type === "delivery" ? "تحویل" : "جمع آوری"} مطمئن هستید؟`, [{
      text: "انصراف",
      style: "cancel"
    }, {
      text: "تایید",
      onPress: () => {
        if (action) {
          action();
        }
      }
    }], {
      cancelable: false
    });
  }
};

function normalizeInputUseCounter(date, end, policy) {
  if (!!date && policy === "customer") {
    let [a] = date.split("T");
    return `${a}T${end}`;
  } else {
    return "";
  }
}

function LogisticTaskFooter(props) {
  let taskStatus = props.data?.status;
  let logisticTypeText = props.data.task_type === "delivery" ? "تحویل" : "جمع آوری";
  let notAllowedToChangeTask = taskStatus === "not_present" || taskStatus === "canceled" || taskStatus === "done"; // let showTimerOnCollection =
  //   taskStatus === "unassigned" || taskStatus === "assigned";
  // let showTimerOnDelivery =
  //   taskStatus === "unassigned" ||
  //   taskStatus === "assigned" ||
  //   taskStatus === "loaded";
  // let showTimer =
  //   props.data.task_type === "collection"
  //     ? showTimerOnCollection
  //     : showTimerOnDelivery;
  // let { text } = useConter(
  //   normalizeInputUseCounter(
  //     props.data?.period?.date,
  //     props.data?.period?.end,
  //     props.policy
  //   ),
  //   showTimer
  // );

  let footer = [];

  if (taskStatus === "canceled") {
    footer.push( /*#__PURE__*/_react.default.createElement(_.Typography, {
      color: "red.dark"
    }, logisticTypeText, " \u0644\u063A\u0648 \u0634\u062F\u0647 \u0627\u0633\u062A."));
  } else if (!!props.data?.driver) {
    footer.push( /*#__PURE__*/_react.default.createElement(_AssignedDriver.default, {
      data: props.data.driver,
      info: props.inPerson ? /*#__PURE__*/_react.default.createElement(_.Button, {
        onPress: () => {
          _reactNative.Linking.openURL(`https://www.google.com/maps/place/${props.data?.address_longitude},${props.data?.address_latitude}`);
        }
      }, "\u0646\u0645\u0627\u06CC\u0634 \u062F\u0631 \u0646\u0642\u0634\u0647") : /*#__PURE__*/_react.default.createElement(_LogisticTaskStatus.default, {
        status: taskStatus
      })
    }));
  }

  if (!notAllowedToChangeTask && props.onCanceled && props.policy === "pishkhan") {
    footer.push( /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Button, {
      onPress: () => confirmationAlert(props.data.task_type, props.onCanceled),
      fill: "transparent",
      textColor: "red.dark"
    }, "\u0644\u063A\u0648 ", logisticTypeText, " ")));
  }

  if (props.onAdd) {
    footer.push( /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Button, {
      onPress: () => {
        if (props.onAdd) {
          props.onAdd();
        }
      },
      fill: true
    }, "\u062A\u0646\u0638\u06CC\u0645 \u0632\u0645\u0627\u0646 ", logisticTypeText, " ")));
  }

  if (props.data.status === "unassigned" && props.policy === "customer") {
    footer.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Button, {
      onPress: props.onReschedule,
      fill: true
    }, "\u062A\u063A\u06CC\u06CC\u0631 \u0632\u0645\u0627\u0646"))));
  } // id=0 is for client-generated task
  // if (showTimer && !!text && props.data.id != 0) {
  //   footer.push(
  //     <>
  //       <Stack distribution="space-between" px="s">
  //         <Typography>تا {logisticTypeText} سفارش</Typography>
  //         <Stack distribution="center">
  //           {/* <Typography ff="mainBold">{text}</Typography> */}
  //           <Spacer size="m" />
  //           {props.logisticTimeIcon}
  //         </Stack>
  //       </Stack>
  //     </>
  //   );
  // }


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, footer.map((component, index) => {
    if (footer.length - 1 === index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, component);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, component, /*#__PURE__*/_react.default.createElement(_.Divider, {
        size: "xxxl"
      }));
    }
  }));
}

var _default = LogisticTaskFooter;
exports.default = _default;